// routes.ts

export const ROUTES = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  START: "/start",
  LOGIN_EMAIL: "/login-email", // <-- Add this if used
  DASHBOARD_CUSTOMERS: "/dashboard/customers",
  USER_PROFILE: "/user-correction/user-profile",
  KYC_DETAILS: "/user-correction/kyc-details",
  MARKET_UPDATE: "/user-correction/market-update",
  FEATURE_FLIP: "/feature-flip",
  PROVIDER_CREATE: "/provider/create",
  PROVIDER_VIEW: "/provider/view",
  TOOL_CREATE: "/provider/tool/create",
  PROJECT: (id: string) => `/feature-flip/project/${id}`,
  PROJECT_FEATURES: (id: string) => `/feature-flip/project/${id}/features`,
  PROJECT_SEGMENTS: (id: string) => `/feature-flip/project/${id}/segments`,
  FEATURE_DETAILS: (projectId: string, featureId: string) =>
    `/feature-flip/project/${projectId}/features/${featureId}`,
};

